import { Box, IconButton, Tooltip } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import {
  MultiSelectChips,
  type MultiSelectOption,
} from '../../../../../components/inputs/MultiSelectChips';
import { StyledSectionHeading } from '../../../../../components/inputs/InputLabel';
import { StyledQuestionMark } from '../../../../../components/QuestionMark';

type LicensesFieldProps = {
  value: string[];
  options: string[];
  disabled?: boolean;
  onChange: (event: SelectChangeEvent<string[]>) => void;
};

export const LicensesField = ({
  value,
  options,
  disabled = false,
  onChange,
}: LicensesFieldProps) => {
  const selectOptions: MultiSelectOption[] = options.map((option) => ({
    value: option,
    label: option,
  }));

  const labelId = 'licenses-label';

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <StyledSectionHeading id={labelId}>
          Licenses
        </StyledSectionHeading>
        <Tooltip
          title="Licenses (you are able to select more than one option)"
          placement="top"
        >
          <IconButton size="small" sx={{ marginLeft: '3px' }}>
            <StyledQuestionMark fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <MultiSelectChips
        id="licenses"
        name="licenses"
        labelId={labelId}
        value={value}
        options={selectOptions}
        disabled={disabled}
        onChange={onChange}
      />
    </>
  );
};
